/**
 *
 *  Upcoming Experiences Slider - used in Lifestyle LP, and Become a Member page
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 2024-08-05.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */
import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

// Components
import Button from "../../Button/Button";
import { SliderNextButton } from "../../SliderNextButton/SliderNextButton";
import { SliderPrevButton } from "../../SliderPrevButton/SliderPrevButton";
import { UpcomingClassPlaceholder } from "./UpcomingClassPlaceholder/UpcomingClassPlaceholder";

// Hooks
import useTheme from "../../ThemeProvider/useTheme/useTheme";

// Icons
import ArrowRightIcon from "../../../icons/ArrowRightIcon";
import CheckNiceIcon from "../../../icons/CheckNiceIcon";

// Utils
import { clientWidth } from "../../../utils";

const sliderResponsiveSettings = [
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 960,
    settings: {
      slidesToShow: 2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1180,
    settings: {
      slidesToShow: 2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 2560,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 5000,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  { breakpoint: 10000, settings: "unslick" },
];

export const UpcomingExperiencesSlider = ({
  className,
  showArrows,
  itemComponent: ItemComponent,
  itemProps,
  sliderAutoplay,
  futureEvents,
  isFetching,
}) => {
  const { theme } = useTheme();

  let content = null;

  const slickInitialised = true;

  if (slickInitialised && (futureEvents?.length || isFetching)) {
    content = (
      <Slider
        className={`${
          className ? `${className} ` : ""
        }future-events-carousel tbk--ml-1 tbk--mr-1 tbk-text-center`}
        dots={true}
        dotsClass={
          "slick-dots !tbk-inline-block tbk--translate-x-1/2 tbk-left-1/2 tbk-whitespace-nowrap"
        }
        arrows={showArrows}
        autoplay={sliderAutoplay}
        autoplaySpeed={4000}
        pauseOnFocus
        pauseOnDotsHover
        pauseOnHover
        infinite={futureEvents.length > 1}
        speed={500}
        slidesToShow={2}
        slidesToScroll={1}
        initialSlide={0}
        responsive={sliderResponsiveSettings}
        nextArrow={
          <SliderNextButton buttonClassName="tbk-w-[48px] tbk-h-[48px]" />
        }
        prevArrow={
          <SliderPrevButton buttonClassName="tbk-w-[48px] tbk-h-[48px]" />
        }
        // onSwipe={handleSlideSwipe}
      >
        {futureEvents?.length && !isFetching
          ? futureEvents.map((evt, index) => (
              <div
                id={`slide-${index}`}
                className="slide upcoming-experiences-item tbk-pl-1 tbk-pr-1"
                key={index}
                // onClick={() => openGalleryCarouselModal(index)}
              >
                <div className="content slide-bg tbk-h-full tbk-w-full">
                  <ItemComponent item={evt} {...itemProps} />
                </div>
              </div>
            ))
          : isFetching &&
            [...new Array(6)].map((v) => (
              <UpcomingClassPlaceholder
                key={v}
                {...itemProps}
                className={`${className} tbk-pl-1 tbk-pr-1`}
              />
            ))}
      </Slider>
    );
  }

  return content;
};

export default UpcomingExperiencesSlider;
